var _rect, _g, _g2, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-15 -10 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#DA251d",
    x: -20,
    y: -15,
    width: 40,
    height: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g",
    transform: "translate(0,-6)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "g1",
    fill: "#FF0",
    points: "0,0 0,6 4,6",
    transform: "rotate(18)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g1",
    transform: "scale(-1,1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "rotate(72)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "rotate(72)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g2",
    transform: "scale(-1,1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVn);
export default __webpack_public_path__ + "static/media/vn.b05bb20cdd1fa039f12f1b6abe8de1a3.svg";
export { ForwardRef as ReactComponent };